'use strict';

import {initCommonModules} from './commons';
import {initModules} from './modules';

window.fkCommons = {};


initModules();
initCommonModules();
